"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HexColors = {
    a: {
        backgroundColor: '#8b4e83',
    },
    b: {
        backgroundColor: '#93b0b6',
    },
    c: {
        backgroundColor: '#eeb65e',
    },
    d: {
        backgroundColor: '#a5d86e',
    },
    e: {
        backgroundColor: '#a9d1df',
    },
    f: {
        backgroundColor: '#7e977f',
    },
    g: {
        backgroundColor: '#9b9b73',
    },
    h: {
        backgroundColor: '#93c1b7',
    },
    i: {
        backgroundColor: '#efcfbe',
    },
    j: {
        backgroundColor: '#ff7b88',
    },
    k: {
        backgroundColor: '#c3c7c6',
    },
    l: {
        backgroundColor: '#6aac9c',
    },
    m: {
        backgroundColor: '#b3cfae',
    },
    n: {
        backgroundColor: '#42cacb',
    },
    o: {
        backgroundColor: '#af6378',
    },
    p: {
        backgroundColor: '#dfaa40',
    },
    q: {
        backgroundColor: '#e79258',
    },
    r: {
        backgroundColor: '#85c45e',
    },
    s: {
        backgroundColor: '#50c694',
    },
    t: {
        backgroundColor: '#fb9482',
    },
    u: {
        backgroundColor: '#f9e3ac',
    },
    v: {
        backgroundColor: '#92d687',
    },
    w: {
        backgroundColor: '#61bbcd',
    },
    x: {
        backgroundColor: '#d98080',
    },
    y: {
        backgroundColor: '#859095',
    },
    z: {
        backgroundColor: '#69abcb',
    },
};
exports.default = HexColors;
